import React, { Component, Fragment } from 'react'
import STATES from './states'
import './style.scss'

export class UfSelect extends Component {
	constructor(props) {
		super(props)
		this.canToggle = true
		this.state = {
			active: false,
		}
	}

	renderOptions = () => {
		return stateOptions.map((state) => (
			<option value={state.value}>{state.label}</option>
		))
	}

	toggleSelectedActive = (event) => {
		const active = this.state.active ? false : true
		this.setState({ active })
	}

	handleStateOptionSelected = (state) => {
		this.setState({
			active: false,
		})
		this.props.handleSelection(state)
	}

	renderStateOptions = () => {
		let counter = 1
		return STATES.map((state) => {
			return (
				<div
					onClick={(e) => {
						this.handleStateOptionSelected(state)
					}}
					key={counter++}
					className="state-option">
					<input
						type="radio"
						className="state-radio"
						id={state.value}
						name="states"
						value={state.value}
					/>
					<label htmlFor={state.value}>{state.label}</label>
				</div>
			)
		})
	}

	render() {
		const { active } = this.state
		const { selected } = this.props
		return (
			<div>
				<div className="select-box-states">
					<div
						className={
							active
								? 'container-options-states active'
								: 'container-options-states'
						}>
						{this.renderStateOptions()}
					</div>
					<button
						type="button"
						onClick={this.toggleSelectedActive}
						className="selected">
						{selected}
					</button>
					<span className="down-arrow-separator-line" />
					<div className="down-arrow" />
				</div>
			</div>
		)
	}
}
